// Save confirmed "talk to log" entries, with one Undo for the lot.

import { Check } from 'lucide-react';
import { proposalToEvent, type LogProposal } from '../domain/parse.ts';
import { MINUTE } from '../domain/time.ts';
import type { LogEvent } from '../domain/types.ts';
import { toast } from '../ui/toast.tsx';
import { currentPerson, deleteEvent, endSleep, logEvent, startSleep } from './actions.ts';
import { uid } from './ids.ts';
import { data } from './index.ts';

export function commitProposals(chosen: LogProposal[]): LogEvent[] {
  const now = Date.now();
  const logged: LogEvent[] = [];
  for (const p of chosen) {
    const at = now - p.minutesAgo * MINUTE;
    if (p.type === 'nap' && !p.durationMin) logged.push(startSleep(at));
    else if (p.type === 'woke') {
      const e = endSleep(at);
      if (!e) logged.push(logEvent('sleep', {}, { at: at - 45 * MINUTE, end: at, note: 'Start time guessed — edit if you know it' }));
    } else {
      const ev = proposalToEvent(p, now, uid(), currentPerson());
      if (ev) {
        data().store.put('events', ev);
        logged.push(ev);
      }
    }
  }
  toast({
    message: chosen.length === 1 ? 'Logged 1 thing' : `Logged ${chosen.length} things`,
    tone: 'good',
    icon: Check,
    actions: logged.length ? [{ label: 'Undo', onClick: () => logged.forEach((e) => deleteEvent(e.id)) }] : [],
  });
  return logged;
}
